import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { ChangeEvent, FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoDetalle from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumentoDetalle';
import IBodegaDivisiones from 'Infotrack@Modelos/smartStock/bodegasDivisiones/entidades/bodegasDivisiones';

interface ICampoDivisionOrigenProps {
    deshabilitado: boolean;
    divisionesOrigen?: IBodegaDivisiones[];
    manejarCambioCampo: (
        nombreCampo: keyof IDocumentoDetalle,
        nuevoValor: IDocumentoDetalle[keyof IDocumentoDetalle]
    ) => any;
    valor: number | undefined;
    requerido:boolean
}

const CampoDivisionOrigen: FunctionComponent<ICampoDivisionOrigenProps> = ({
    deshabilitado,
    manejarCambioCampo,
    divisionesOrigen,
    valor,
    requerido
}) => (
    <Autocomplete
        disabled={deshabilitado}
        onChange={(_: ChangeEvent<{}>, value: IBodegaDivisiones | null) =>
            manejarCambioCampo('DivisionOrigen', value ? value.DivisionId : undefined)
        }
        options={divisionesOrigen || []}
        getOptionLabel={(d) => d.DivisionDescripcion}
        renderInput={(params) => (
            <TextField
                {...params}
                required={requerido}
                fullWidth
                label={<Texto id="DetallesFormulario.CampoDivisionOrigen.Nombre" />}
            />
        )}
        value={divisionesOrigen ? divisionesOrigen.find((d) => d.DivisionId === valor) || null : null}
    />
);

export default CampoDivisionOrigen;
